import React, { Component } from "react";
import classnames from "classnames";
import moment from "moment";
import DatePicker from "react-datepicker";
import fileDownload from "react-file-download";
import { toast } from "react-toastify";
import Presenter from "../../../presenter.js";
import RequestProperties from "../../request.props.js";

// Component
/*import Select from 'react-select';
import iconMaping from '../../../../utils/IconMaping.js';
import generateAutocomplete from '../../../../utils/generateAutocomplete.js';*/

import ModalDetail from "../Modal/ModalDetail.js";

import ReportViewRow from "./ReportViewRow.js";
import ReportView from "./ReportView.js";

import SelectQuery from "../../../../component/SelectQuery.js";
import windowStop from "../../../../utils/windowStop.js";

class ReportList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      status: "",
      type: "",
      assigned_to: "",
      site: "",
      location: "",
      purchased_by: "",
      start_purchase_date: null,
      finish_purchase_date: null,
      start: null,
      finish: null,
      vendor: "",
      status_label: "",
      type_label: "",
      assigned_to_label: "",
      site_label: "",
      location_label: "",
      purchased_by_label: "",
      vendor_label: "",

      // Date
      minFinish: moment(),

      //modal
      is_toggle: false,
      modal_data: null,

      //Loading
      loadingPreview: false,
      loadingDownload: false,
      isLoadingLoadmore: true,
      isPreparing: true,

      //Row
      viewRowElement: [],
      countReport: 0,
      nextPage: null,
      assetTotalValue: []
    };

    this.onDownload = this.onDownload.bind(this);
    this.onDownloadSuccess = this.onDownloadSuccess.bind(this);
    this.onDownloadFailed = this.onDownloadFailed.bind(this);

    this.onReadReportSuccess = this.onReadReportSuccess.bind(this);
    this.onReadReportFailed = this.onReadReportFailed.bind(this);

    this.onReadAssetTotalValueSuccess = this.onReadAssetTotalValueSuccess.bind(
      this
    );
    this.onReadAssetTotalValueFailed = this.onReadAssetTotalValueFailed.bind(
      this
    );

    this.viewReport = this.viewReport.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.handleSiteChange = this.handleSiteChange.bind(this);
  }

  toggleModal(modal_data) {
    this.setState({
      is_toggle: !this.state.is_toggle,
      modal_data: modal_data
    });
  }

  handleSiteChange(e) {
    this.setState(
      {
        site: e === null ? "" : e.value,
        site_label: e === null ? "" : "|" + e.label,
        location: "",
        location_label: ""
      },
      () => this._location.reload("", true)
    );
  }

  onReadReport(action) {
    this.assetTotalValue = [];
    Presenter.ReadReport(
      RequestProperties.ReadReport(
        action,
        this,
        this.onReadReportSuccess,
        this.onReadReportFailed
      )
    );
    if (action === "Read") {
      Presenter.ReadAssetTotalValue(
        RequestProperties.ReadAssetTotalValue(
          action,
          this,
          this.onReadAssetTotalValueSuccess,
          this.onReadAssetTotalValueFailed
        )
      );
    }
  }

  onReadReportSuccess(params, response) {
    if (params.action === "Read") {
      this.setState({
        loadingPreview: false,
        isPreparing: false,
        isLoadingLoadmore: false,
        nextPage: response.data.next,
        countReport: response.data.count,
        viewRowElement: this.generateRow(response.data.results)
      });
    } else {
      this.setState({
        loadingPreview: false,
        isPreparing: false,
        isLoadingLoadmore: false,
        nextPage: response.data.next,
        countReport: response.data.count,
        viewRowElement: [
          ...this.state.viewRowElement,
          ...this.generateRow(response.data.results)
        ]
      });
    }
  }

  onReadReportFailed(response) {
    this.setState({
      loadingPreview: false,
      isPreparing: false
    });
  }

  onReadAssetTotalValueSuccess(params, response) {
    this.setState({
      assetTotalValue: response.data
    });
  }

  onReadAssetTotalValueFailed(response) {
    console.log(response);
  }

  generateRow(row) {
    var element = row.map((val, index) => {
      return (
        <ReportViewRow
          rowData={val}
          key={val.Alias + val.PurchaseOrder + index}
          toggleModal={this.toggleModal}
        />
      );
    });
    return element;
  }

  viewReport() {
    window.scrollTo(0, 420);
    this.setState({ loadingPreview: true });
    this.onReadReport("Read");
  }

  onDownload(type) {
    // let isSafarii = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
    let isSafarii = !!navigator.userAgent.match(/Version\/[\d]+.*Safari/);
    let iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    if (isSafarii || iOS) {
      toast.error("Your browser doesn't support to download file");
    } else {
      this.setState({ loadingDownload: true });
      Presenter.DownloadReport(
        RequestProperties.DownloadReport(
          type,
          this,
          this.onDownloadSuccess,
          this.onDownloadFailed
        )
      );
    }
  }

  onDownloadSuccess(params, response) {
    this.setState({ loadingDownload: false });
    let filename;
    let fname = moment().format("YYYYMMDD") + "-Tool-Value-Report";

    if (params.data.doc_type === "pdf") {
      filename = fname + "." + params.data.doc_type;
      fileDownload(response.data, filename);
    } else {
      filename = fname + "." + params.data.doc_type;
      fileDownload(
        response.data,
        filename,
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      );
    }
  }

  onDownloadFailed(response) {
    alert("Download failed, please refresh page and try again");
    this.setState({ loadingDownload: false });
  }

  hanldeSiteChange(siteALias) {
    this.setState({
      site: siteALias,
      location_filtered: this.filterLocation(siteALias)
    });
    this.filterLocation(siteALias);
  }

  changeStart(date) {
    if (this.state.finish < moment(date)) {
      this.setState({
        minFinish: moment(date),
        finish: moment(date).add(1, "days"),
        finish_purchase_date: date.format("YYYY-MM-DD")
      });
    }

    this.setState({
      start: moment(date),
      start_purchase_date: date.format("YYYY-MM-DD")
    });
  }

  changeEnd(date) {
    this.setState({
      finish: moment(date),
      finish_purchase_date: date.format("YYYY-MM-DD")
    });
  }

  onClear() {
    this.setState({
      status: "",
      type: "",
      assigned_to: "",
      site: "",
      location: "",
      purchased_by: "",
      start_purchase_date: null,
      finish_purchase_date: null,
      start: null,
      finish: null,
      vendor: ""
    });
  }

  componentDidMount() {
    this.onReadReport("Read");
  }

  componentWillUnmount() {
    windowStop();
  }

  /* Readmore */
  LoadMore() {
    this.setState({ isLoadingLoadmore: true });
    this.onReadReport("Next");
  }

  renderLoadMoreButton() {
    if (this.state.isLoadingLoadmore) {
      return (
        <div className="text-center">
          <button className="btn btn-default" disabled>
            <i className="fa fa-spinner fa-pulse fa-fw"></i>&nbsp; Load report
          </button>
        </div>
      );
    } else {
      if (this.state.nextPage != null) {
        return (
          <div className="text-center">
            <button
              className="btn btn-primary"
              onClick={() => {
                this.LoadMore();
              }}
            >
              Load More Report
            </button>
          </div>
        );
      }
    }
  }

  renderRowElement() {
    if (this.state.isPreparing) {
      return (
        <tr>
          <td className="table-loading-inside" colSpan="100%">
            Preparing report . . .
          </td>
        </tr>
      );
    } else {
      if (this.state.countReport === 0) {
        return (
          <tr>
            <td className="table-not-found" colSpan="100%">
              <span className="icon-drawer"></span>&nbsp;Report empty
            </td>
          </tr>
        );
      } else {
        return this.state.viewRowElement;
      }
    }
  }

  render() {
    return (
      <div className="card-block">
        <div
          className={classnames("prepare-preview-report", {
            "show-f": this.state.loadingPreview
          })}
        >
          <h3 className="text-center">Please wait, Preparing the report</h3>
          <i className="fa fa-spinner fa-spin"></i>
        </div>
        <div
          className={classnames("prepare-preview-report", {
            "show-f": this.state.loadingDownload
          })}
        >
          <h3 className="text-center">
            Please wait, Preparing to download report
          </h3>
          <i className="fa fa-spinner fa-spin"></i>
        </div>
        <div className="row">
          <div className="col-sm-12 book-a-tool-title">
            <h4 className="card-title mb-0">
              <span>Filter Report</span>
            </h4>
          </div>
        </div>
        <hr />
        <form className="form-horizontal">
          <div className="row">
            {/* Right */}
            <div className="col-md-5">
              <div className="form-group row">
                <label className="col-md-3 col-form-label">Status</label>
                <div className="col-md-9">
                  <SelectQuery
                    placeholder="Type Asset Status"
                    value={this.state.status}
                    onChange={e =>
                      this.setState({
                        status: e === null ? "" : e.value,
                        status_label: e === null ? "" : "|" + e.label
                      })
                    }
                    urlKey="read-asset-status-autocomplete"
                    valKey="Alias"
                    valLabel="Name"
                    isCreatable={false}
                    isClearable={true}
                    UserReducer={this.props.UserReducer}
                  />
                </div>
              </div>
              <div className="form-group row">
                <label className="col-md-3 col-form-label">Type</label>
                <div className="col-md-9">
                  <SelectQuery
                    placeholder="Type Asset Type"
                    value={this.state.type}
                    onChange={e =>
                      this.setState({
                        type: e === null ? "" : e.value,
                        type_label: e === null ? "" : "|" + e.label
                      })
                    }
                    urlKey="read-asset-type-autocomplete"
                    valKey="Alias"
                    valLabel="Name"
                    isCreatable={false}
                    isClearable={true}
                    UserReducer={this.props.UserReducer}
                  />
                </div>
              </div>
              <div className="form-group row">
                <label className="col-md-3 col-form-label">Assigned to</label>
                <div className="col-md-9">
                  <SelectQuery
                    placeholder="Type Assigned to"
                    value={this.state.assigned_to}
                    onChange={e =>
                      this.setState({
                        assigned_to: e === null ? "" : e.value,
                        assigned_to_label: e === null ? "" : "|" + e.label
                      })
                    }
                    urlKey="read-user-autocomplete"
                    valKey="Username"
                    valLabel="Name"
                    extra="all=true"
                    isCreatable={false}
                    isClearable={true}
                    UserReducer={this.props.UserReducer}
                  />
                </div>
              </div>
              <div className="form-group row">
                <label className="col-md-3 col-form-label">Site</label>
                <div className="col-md-9">
                  <SelectQuery
                    placeholder="Type Site"
                    value={this.state.site}
                    onChange={this.handleSiteChange}
                    urlKey="read-site-autocomplete"
                    valKey="Alias"
                    valLabel="Name"
                    extra="all=true"
                    isCreatable={false}
                    isClearable={true}
                    UserReducer={this.props.UserReducer}
                  />
                </div>
              </div>
              <div className="form-group row">
                <label className="col-md-3 col-form-label">Location</label>
                <div className="col-md-9">
                  <SelectQuery
                    placeholder="Type Location"
                    value={this.state.location}
                    onChange={e =>
                      this.setState({
                        location: e === null ? "" : e.value,
                        location_label: e === null ? "" : "|" + e.label
                      })
                    }
                    urlKey="read-location-autocomplete"
                    valKey="Alias"
                    valLabel="Name"
                    isCreatable={false}
                    isClearable={true}
                    extra={"site=" + this.state.site}
                    onRef={asd => (this._location = asd)}
                    UserReducer={this.props.UserReducer}
                  />
                </div>
              </div>
            </div>

            {/* Left */}
            <div className="col-md-5 offset-md-2">
              <div className="form-group row">
                <label className="col-md-3 col-form-label">Purchased By</label>
                <div className="col-md-9">
                  <SelectQuery
                    placeholder="Type Purchase by"
                    value={this.state.purchased_by}
                    onChange={e =>
                      this.setState({
                        purchased_by: e === null ? "" : e.value,
                        purchased_by_label: e === null ? "" : "|" + e.label
                      })
                    }
                    urlKey="read-user-autocomplete"
                    valKey="Username"
                    valLabel="Name"
                    isClearable
                    extra="all=true"
                    UserReducer={this.props.UserReducer}
                  />
                </div>
              </div>
              <div className="form-group row">
                <label className="col-md-3 col-form-label">
                  Purchased Date
                </label>
                <div className="col-md-4">
                  <span
                    className="clear-date-report no-select"
                    onClick={() => {
                      this.setState({
                        start: null,
                        finish: null,
                        start_purchase_date: null,
                        finish_purchase_date: null
                      });
                    }}
                  >
                    ×
                  </span>
                  <DatePicker
                    placeholderText="Start date"
                    className="form-control"
                    dateFormat="YYYY-MM-DD"
                    // minDate ={moment()}
                    selected={this.state.start}
                    onChange={e => this.changeStart(e)}
                    readOnly
                    withPortal
                  />
                </div>
                <div className="col-md-1 col-form-label">To</div>
                <div className="col-md-4 ">
                  <span
                    className="clear-date-report no-select"
                    onClick={() => {
                      this.setState({
                        start: null,
                        finish: null,
                        start_purchase_date: null,
                        finish_purchase_date: null
                      });
                    }}
                  >
                    ×
                  </span>
                  <DatePicker
                    placeholderText="End date"
                    className="form-control"
                    dateFormat="YYYY-MM-DD"
                    // minDate ={this.state.minFinish}
                    selected={this.state.finish}
                    onChange={e => this.changeEnd(e)}
                    readOnly
                    withPortal
                  />
                </div>
              </div>
              <div className="form-group row">
                <label className="col-md-3 col-form-label">Vendor</label>
                <div className="col-md-9">
                  <SelectQuery
                    placeholder="Type Vendor"
                    value={this.state.vendor}
                    onChange={e =>
                      this.setState({
                        vendor: e === null ? "" : e.value,
                        vendor_label: e === null ? "" : "|" + e.label
                      })
                    }
                    urlKey="read-vendor-autocomplete"
                    valKey="Name"
                    valLabel="Name"
                    isCreatable={false}
                    isClearable={true}
                    UserReducer={this.props.UserReducer}
                  />
                </div>
              </div>
            </div>
          </div>
        </form>

        <hr />
        <div className="row justify-content-md-center">
          <div className="col-md-2 m-tb-6">
            <button
              type="button"
              className="btn btn-default btn-block"
              onClick={() => this.onClear()}
            >
              Clear All
            </button>
          </div>
          <div className="col-md-2 m-tb-6">
            <button
              type="button"
              className="btn btn-success btn-block"
              onClick={() => this.viewReport()}
            >
              View Report
            </button>
          </div>
          <div className="col-md-2 m-tb-6"></div>
          <div className="col-md-3 m-tb-6">
            <button
              type="button"
              className="btn btn-primary btn-block"
              onClick={() => this.onDownload("pdf")}
            >
              Download PDF
            </button>
          </div>
          <div className="col-md-3 m-tb-6">
            <button
              type="button"
              className="btn btn-primary btn-block"
              onClick={() => this.onDownload("xlsx")}
            >
              Download Excel (.xlsx)
            </button>
          </div>
        </div>
        <hr />

        <ReportView {...this}>{this.renderRowElement()}</ReportView>
        {this.renderLoadMoreButton()}
        <ModalDetail
          is_toggle={this.state.is_toggle}
          toggleModal={this.toggleModal}
          modal_data={this.state.modal_data}
          userReducer={this.props.UserReducer}
        />
      </div>
    );
  }
}

export default ReportList;



// WEBPACK FOOTER //
// ./src/App/report/helper/component/Report/Report.js